import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b948957c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "casestudy_menu" };
const _hoisted_2 = {
    key: 0,
    class: "casestudy_menu__navigation"
};
const _hoisted_3 = { class: "container casestudy_menu__navigation--tabs" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Sort by:", -1));
const _hoisted_5 = {
    key: 1,
    class: "casestudy_menu__navigation--shadow"
};
const _hoisted_6 = { class: "casestudy_menu__subnavigation" };
const _hoisted_7 = {
    key: 0,
    class: "container casestudy_menu__subnavigation--tabs"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 1,
    class: "container casestudy_menu__subnavigation--tabs"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "py-5" };
const _hoisted_12 = { class: "casestudy_menu__content" };
const _hoisted_13 = {
    key: 0,
    class: "container inner"
};
const _hoisted_14 = {
    key: 1,
    class: "container inner"
};
import { ref } from 'vue';
import axios from 'axios';
import InfiniteLoading from "v3-infinite-loading";
export default /*#__PURE__*/ _defineComponent({
    __name: 'casestudy_list',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const items = ref([]);
        const page = ref(1);
        const currentTabSelected = ref(props.d.current_tab_selected ?? 'all-work');
        const currentSubnavTabSelected = ref(props.d.current_subtab_selected ?? null);
        const sectors = ref([]);
        const services = ref([]);
        const showLoadArchiveButton = ref(false); // Initially hide the "Archive" button
        const loadArchiveCount = ref(4);
        const setCurrentTab = (tab) => {
            currentTabSelected.value = tab;
            if (tab === 'service') {
                setCurrentSubNavTab(services.value[0].title);
                loadArchiveCount.value = 4;
            }
            if (tab === 'sector') {
                setCurrentSubNavTab(sectors.value[0].title);
                loadArchiveCount.value = 4;
            }
            if (tab === 'all-work') {
                // Refetch case studies
                refreshItems();
                loadArchiveCount.value = 14;
            }
            window.scrollTo({
                top: 1070,
                behavior: "smooth" // Optional: Smooth scrolling animation
            });
        };
        const refreshItems = () => {
            // Refetch case studies
            (async () => {
                try {
                    page.value = 1;
                    items.value = [];
                    await fetchItems(props);
                }
                catch (error) {
                    console.error('Error fetching items:', error);
                }
            })();
        };
        const isTabSelected = (tab) => {
            return currentTabSelected.value === tab;
        };
        const setCurrentSubNavTab = (tab) => {
            currentSubnavTabSelected.value = tab;
            // Refetch case studies
            items.value = [];
            refreshItems();
        };
        const isSubNavTabSelected = (tab) => {
            return currentSubnavTabSelected.value === tab;
        };
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 1023);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 1023;
        });
        const fetchItems = async ($state) => {
            const category = currentTabSelected.value !== 'all-work' ? currentTabSelected.value : null;
            const subCategory = currentSubnavTabSelected.value ?? null;
            try {
                if (currentTabSelected.value !== 'clients') {
                    const response = await axios.get('/api/casestudies', {
                        params: {
                            category,
                            subCategory,
                            page: page.value,
                        },
                    });
                    for (const casestudy of response.data.data) {
                        // Check if casestudy.alias does not match any existing alias in casestudies
                        const isUnique = items.value.every(existingItem => existingItem.alias !== casestudy.alias);
                        if (isUnique) {
                            items.value.push(casestudy);
                        }
                    }
                }
                else {
                    const response = await axios.get('/api/clients', {
                        params: {
                            page: page.value,
                        },
                    });
                    for (const client of response.data.data) {
                        // Check if client.alias does not match any existing alias in client
                        const isUnique = items.value.every(existingClient => existingClient.alias !== client.alias);
                        if (isUnique) {
                            items.value.push(client);
                        }
                    }
                }
                page.value++;
                showLoadArchiveButton.value = items.value.length == loadArchiveCount.value;
            }
            catch (error) {
                console.log(error);
                $state.error();
            }
        };
        const fetchServices = () => {
            axios.get('/api/services')
                .then(response => {
                for (const service of response.data.data) {
                    services.value.push(service);
                }
            })
                .catch(error => {
                console.error(error);
            });
        };
        const fetchSectors = () => {
            axios.get('/api/sectors')
                .then(response => {
                for (const sector of response.data.data) {
                    sectors.value.push(sector);
                }
            })
                .catch(error => {
                console.error(error);
            });
        };
        const calculateArchiveCount = () => {
            if (currentTabSelected.value === 'service') {
                loadArchiveCount.value = 4;
            }
            if (currentTabSelected.value === 'sector') {
                loadArchiveCount.value = 4;
            }
            if (currentTabSelected.value === 'all-work') {
                loadArchiveCount.value = 14;
            }
        };
        fetchServices();
        fetchSectors();
        calculateArchiveCount();
        return (_ctx, _cache) => {
            const _component_floating_videos_with_sticky_text = _resolveComponent("floating-videos-with-sticky-text");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!props.d.isClientListing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("a", {
                                href: "/work",
                                class: _normalizeClass(["casestudy_menu__navigation--tab no-style", { 'casestudy_menu__navigation--tab__active': isTabSelected('all-work') }]),
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (setCurrentTab('all-work')), ["prevent"]))
                            }, " All Work ", 2),
                            _createElementVNode("a", {
                                href: "#",
                                class: _normalizeClass(["casestudy_menu__navigation--tab no-style", { 'casestudy_menu__navigation--tab__active': isTabSelected('service') }]),
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (setCurrentTab('service')), ["prevent"]))
                            }, " Service ", 2),
                            _createElementVNode("a", {
                                href: "#",
                                class: _normalizeClass(["casestudy_menu__navigation--tab no-style", { 'casestudy_menu__navigation--tab__active': isTabSelected('sector') }]),
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (setCurrentTab('sector')), ["prevent"]))
                            }, " Sector ", 2)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (!props.d.isClientListing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                    (isTabSelected('service'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
                                return (_openBlock(), _createElementBlock("a", {
                                    key: index,
                                    href: "#",
                                    class: _normalizeClass(["casestudy_menu__navigation--tab no-style", { 'casestudy_menu__navigation--tab__active': isSubNavTabSelected(service.title) }]),
                                    onClick: _withModifiers(($event) => (setCurrentSubNavTab(service.title)), ["prevent"])
                                }, _toDisplayString(service.title), 11, _hoisted_8));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (isTabSelected('sector'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectors.value, (sector, index) => {
                                return (_openBlock(), _createElementBlock("a", {
                                    key: index,
                                    href: "#",
                                    class: _normalizeClass(["casestudy_menu__navigation--tab no-style", { 'casestudy_menu__navigation--tab__active': isSubNavTabSelected(sector.title) }]),
                                    onClick: _withModifiers(($event) => (setCurrentSubNavTab(sector.title)), ["prevent"])
                                }, _toDisplayString(sector.title), 11, _hoisted_10));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass([{ 'pt-4': index === 0 }]),
                                "simply-fade": "fade"
                            }, [
                                _createVNode(_component_floating_videos_with_sticky_text, {
                                    d: { simpleDesign: false, floating_videos_with_sticky_text_repeatable: [item], show_more_cta: 'false', padding_top: 'top_spacing-50', padding_bottom: 'bottom_spacing-50' }
                                }, null, 8, ["d"])
                            ], 2));
                        }), 128)),
                        (!showLoadArchiveButton.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_unref(InfiniteLoading), {
                                    distance: 200,
                                    onInfinite: fetchItems
                                })
                            ]))
                            : _createCommentVNode("", true),
                        (showLoadArchiveButton.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("a", {
                                    class: "load-archive-button",
                                    onClick: fetchItems
                                }, _toDisplayString(props.d.isClientListing ? 'More' : 'Work Archive'), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
